// extracted by mini-css-extract-plugin
module.exports = {"summaryLengthButtons":"styles-module__summaryLengthButtons___vw_Ai","active":"styles-module__active___3b3LK"};